// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__H7T2i","selects":"Documents_selects__3jT_D"};